import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axiosInstance from "../helpers/axiosInstance";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const profileRef = useRef(null);

  const [profileImage, setProfileImage] = useState("/default-profile.png");
  const [user, setUser] = useState({});

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    if (token) {
      try {
        const decoded = jwtDecode(token);

        const fetchUserProfile = async () => {
          try {
            const response = await axiosInstance.get(`/api/auth/user/${decoded.userId}`);
            const { profile_image } = response.data.user;

            if (profile_image) {
              setProfileImage(`${process.env.REACT_APP_API_BASE_URL}uploads/${profile_image}`);
            }
          } catch (error) {
            console.error("Error fetching user profile image:", error);
          }
        };

        fetchUserProfile();
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    if (token) {
      try {
        const decoded = jwtDecode(token);
        const userId = decoded.userId;

        axiosInstance.get(`/api/auth/user/${userId}`)
          .then((res) => {
            setUser(res.data.user);
          })
          .catch((err) => {
            console.error("Failed to fetch user details:", err);
          });
      } catch (err) {
        console.error("Error decoding token:", err);
      }
    }
  }, []);

  const pageTitles = {
    "/": "DASHBOARD",
    "/health": "HEALTH",
    "/bay-info": "BAY INFO",
    "/profile": "PROFILE",
    "/vehicleentry": "ENTRY OF VEHICLE",
    "/device": "DEVICE",
    "/device/:id": "DEVICE DETAILS",
    "/addDevice": "ADD DEVICE",
    "/shop": "SHOP",
    "/bay": "BAY",
    "/trip": "TRIP",
    "/addTrip": "ADD TRIP",
    "/trip/:id": "TRIP DETAILS",
    "/shop/:id" : "SHOP DETAILS",
    "/vendor": "VENDOR",
    "/vendor/:id": "VENDOR DETAILS",
    "/employee": "EMPLOYEE",
    "/employee/:id": "EMPLOYEE DETAILS",
    "/vehicle_schedule": "VEHICLE LOGS",
    "/vehicle_info": "VEHICLE INFO",
    "/parkingexit":"PARKING EXIT"
  };

  const getPageTitle = (pathname) => {
    if (pageTitles[pathname]) return pageTitles[pathname];
    if (pathname.startsWith("/device/")) return "DEVICE DETAILS";
    if (pathname.startsWith("/bay/")) return "BAY DETAILS";
    if (pathname.startsWith("/trip/")) return "TRIP DETAILS";
    if (pathname.startsWith("/shop/")) return "SHOP DETAILS";
    if (pathname.startsWith("/vendor/")) return "VENDOR DETAILS";
    if (pathname.startsWith("/employee/")) return "EMPLOYEE DETAILS";
    return "DASHBOARD";
  };

  const pageTitle = getPageTitle(location.pathname);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 20px", // Add some padding for spacing
        width: "-webkit-fill-available",
      }}
    >
      {/* Left side: Page Title */}
      <p
        style={{
          fontSize: "20px",
          fontWeight: "bold",
          textTransform: "uppercase",
          margin: 0,
        }}
      >
        {pageTitle}
      </p>

      {/* Right side: Profile Icon and Name */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          cursor: "pointer",
        }}
      >
        <button
          onClick={() => navigate("/profile")}
          style={{
            background: "transparent",
            border: "none",
            padding: 0,
            cursor: "pointer",
          }}
        >
          <img
            alt="Profile"
            src={profileImage || "https://via.placeholder.com/130"}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              marginRight: "10px",
              objectFit: "cover",
            }}
          />
        </button>
        {/* <span
          style={{
            display: window.innerWidth < 768 ? "none" : "inline",
            fontWeight: "500",
          }}
        >
          {user.name}
        </span> */}
      </div>
    </div>
  );
};

export default Header;
